<div class="container">
  <rk-icon-button
    faIcon="fa-filter"
    [bordered]="true"
    [size]="24"
    [style]="{ width: '35px', height: '35px' }"
    (click)="openFilter()"
  ></rk-icon-button>
  <div class="dot" *ngIf="isBacHavingFilters$ | async"></div>
</div>
